import { makeStyles } from "@material-ui/core/styles";

export const useDialogStyles = makeStyles(
  theme => ({
    addTopMargin: {
      marginTop: "10px"
    },
    btnActive: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main,
      color: "#ffffff"
    },
    btnCancel: {
      "&:hover": {
        backgroundColor: "#ffffff"
      },
      backgroundColor: "#ffffff",
      color: theme.palette.primary.dark,
      marginTop: "10px"
    },
    btnInactive: {
      "&:hover": {
        backgroundColor: "#ffffff"
      },
      backgroundColor: "#ffffff",
      color: theme.palette.primary.main
    },
    btnLblDark: {
      color: theme.palette.primary.dark
    },
    btnLblWhite: {
      color: "#ffffff !important"
    },
    btnYes: {
      "&:hover": {
        backgroundColor: theme.palette.primary.main
      },
      backgroundColor: theme.palette.primary.main,
      marginTop: "10px"
    },
    btnsAddDeduct: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: "30px"
    },
    centerItems: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    cursorHand: {
      cursor: "pointer"
    },
    descriptionLabel: {
      margin: "5px 0px 5px 0px"
    },
    fileUploadField: {
      alignItems: "center",
      display: "flex",
      height: "150px",
      justifyContent: "center",
      padding: "0!important"
    },
    image: {
      height: "100%",
      objectFit: "contain",
      userSelect: "none",
      width: "100%"
    },
    imageContainer: {
      "&:hover, &.dragged": {
        "& $imageOverlay": {
          display: "block"
        }
      },
      background: "#ffffff",
      border: "1px solid #eaeaea",
      borderRadius: theme.spacing(),
      height: 140,
      margin: "auto",
      overflow: "hidden",
      position: "relative",
      width: "100%"
    },
    imageGridContainer: {
      position: "relative"
    },
    imageGridContainerBorder: {
      border: "solid #c6c6c6 1px",
      borderRadius: "5px",
      position: "relative"
    },
    labelAsterisk: {
      color: "red"
    },
    marginTop50: {
      marginTop: "50px"
    },
    modal: {
      minHeight: "280px",
      position: "relative"
    },
    modalBottom: {
      textAlign: "center"
    },
    modalCloseBtn: {
      position: "absolute",
      right: "20px"
    },
    modalForm: {
      padding: "25px 50px"
    },
    modalSubtitle: {
      fontSize: "16px",
      fontWeight: 400,
      margin: "0",
      textAlign: "center"
    },
    modalTitleRed: {
      color: "#EC5D77"
    },
    modalTitleText: {
      fontSize: "20px",
      fontWeight: 700,
      textAlign: "center"
    },
    modalTitleTextLeft: {
      fontSize: "17px",
      fontWeight: 600,
      textAlign: "left"
    },
    photosIcon: {
      height: "64px",
      margin: "0 auto",
      width: "64px"
    },
    remittanceDescriptionLabel: {
      color: "#5c5c5cc7",
      margin: "5px 0px 5px 0px"
    },
    remittanceSpiel: {
      color: "#00000066",
      margin: "5px 0px 5px 0px",
      marginTop: "15px"
    },
    uploadRoot: {
      fontSize: 12,
      fontWeight: 600,
      padding: "15px",
      textAlign: "center"
    }
  }),
  { name: "RemittanceRunnerDialogStyles" }
);
